'use client'
import { OrderedList as ChakraList } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { OrderedListProps } from './OrderedList.types'

export default forwardRef(function OrderedList(
  props: OrderedListProps,
  ref: LegacyRef<HTMLOListElement>
) {
  return <ChakraList {...props} ref={ref} translate="no" />
})
